import React, { useState } from 'react';
import './FileUpload.css'; // Add a CSS file for custom styling

const UploadeExcelFile = () => {
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) return alert("Please select a file!");

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch('https://api.assetview.warrantyindia.com/uploadCsv', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        alert('File uploaded successfully');
      } else {
        alert('File upload failed');
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Error uploading file');
    }
  };

  return (
    <div className="file-upload-container">
      <form onSubmit={handleSubmit} className="file-upload-form">
        <h2>Upload CSV File</h2>
        <input
          type="file"
          name="file"
          accept=".csv"
          onChange={handleFileChange}
          className="file-input"
          required
        />
        <button type="submit" className="submit-button">Upload CSV</button>
      </form>
    </div>
  );
};

export default UploadeExcelFile;
